import { Injectable } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppError } from './appError.model';

import { ErrorComponent } from './error.component';

@Injectable()
export class ErrorService {

  constructor(private modalService: NgbModal) { }

  showError(errorMessage: string, causes?: Array<string>): Promise<boolean> {
    const appError: AppError = {
      errorMessage,
      causes
    };

    const modalRef = this.modalService.open(ErrorComponent, { });
    modalRef.componentInstance.error = appError;

    // prueba
    const retunrValue: Promise<boolean> = modalRef.result;
    return retunrValue;
  }

}



// import { Injectable } from '@angular/core';
// import { Observable, Subject } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
// export class ErrorService {

//   private subject: Subject<AppError> = new Subject();

//   constructor() {
//   }

//   getSubject(): Observable<AppError> {
//     return this.subject.asObservable();
//   }

//   showError(errorMessage: string, causes?: Array<string>): void {
//     const appError: AppError = {
//       errorMessage,
//       causes
//     };
//     this.subject.next(appError);
//   }
// }
